import { useRef } from "react";

export interface IframeError {
  code: string;
  message: string;
  details?: string;
}
export const useIframeState = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // Handle iframe load event
  const handleIframeLoad = () => {
    setTimeout(() => {
      const iframe = iframeRef.current;
      if (iframe) {
        iframe.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 100);
  };

  return {
    iframeRef,
    handleIframeLoad,
  };
};
